import { Box, CircularProgress, Typography } from '@mui/material';

type Props = {
  text?: string;
};

export const FullSizeLoader = ({ text }: Props) => {
  return (
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 4,
        backgroundColor: 'rgba(255, 255, 255, 0.3)',
        backdropFilter: 'blur(10px)',
        zIndex: 500,
      }}
    >
      <CircularProgress />
      {text ? <Typography variant={'h6'}>{text}</Typography> : null}
    </Box>
  );
};
